import React from 'react';
import { useStoreState } from 'base/store';
import ListProductImage from '../ListProductImage';
import ListProductName from '../ListProductName';
import ProductPrice from '@base/snippets/ProductPriceV2';
import ListProductRate from '../ListProductRate';
import ListProductFlashsaleProgress from '@base/snippets/ListProduct/ListProductFlashsaleProgress';
import { ListProductProps, ELEMENT_LIST } from '@base/snippets/ListProduct';
import ListProductAddToCartBtn from '@base/snippets/ListProduct/ListProductAddBtn';

const ListProductShowWholeRow = React.forwardRef<HTMLDivElement, ListProductProps>((props, ref) => {
    const {
        moduleElementId,
        addCart,
        aTarget,
        className,
        style,
        product,
        elements = ELEMENT_LIST,
        imageSize,
        spaceAroundPicture,
        spaceBelowPicture,
        imgExtra,
        showTag,
        offTagShow,
        productTag,
        onQuickView,
        onClickProd,
        priceDirection,
        rateType = 'simple',
        isHoverChangeAsset,
        children,
        listConfig,
        'data-t-tar': dataTrackTarget,
        'data-t-pos': dataTrackPosition,
        'data-t-vid': dataTrackVariantId,
        'data-t-price': dataTrackVariantPrice,
    } = props;

    const { ua: { isMobile } } = useStoreState('rootStore')

    return (
        <div
            className={className}
            style={style}
            ref={ref}
            data-t-tar={dataTrackTarget}
            data-t-pos={dataTrackPosition}
            data-t-vid={dataTrackVariantId}
            data-t-price={dataTrackVariantPrice}
        >
            <div className={'sub-wrap flex flex-justify'}>
                <ListProductImage
                    moduleElementId={moduleElementId}
                    aTarget={aTarget}
                    product={product}
                    imageSize={imageSize}
                    spaceAround={spaceAroundPicture}
                    spaceBelow={spaceBelowPicture}
                    showTag={{
                        showProductTag: !!showTag,
                        showActivityTag: false,
                        showActivityOffTag: true
                    }}
                    isHoverChangeAsset={isHoverChangeAsset}
                    offTagShow={offTagShow}
                    productTag={productTag}
                    imgExtra={imgExtra}
                    onQuickView={isMobile ? void 0 : onQuickView}
                    onClick={onClickProd}
                />
                {children || (
                    <div className="info">
                        <div className={'top-boxes'}>
                            {elements.includes('name') && <ListProductName aTarget={aTarget} product={product} onClick={onClickProd}/>}
                            {elements.includes('rate') && <ListProductRate product={product} type={rateType}/>}
                            {/*{elements.includes('points') && <ListProductPoints product={product}/>}*/}
                        </div>

                        <div className={'bottom-boxes'}>
                            <div className='price-rate-wrap'>
                                {elements.includes('price') &&
                                    <ProductPrice
                                        product={product}
                                        showDelPrice={elements.includes('underlinedPrice')}
                                        direction={priceDirection}
                                    />
                                }
                            </div>

                            <div className={'flex flex-middle bar-and-cart'}>
                                {/* flashsale 进度条 */}
                                {elements.includes('flashsale') && (
                                    <ListProductFlashsaleProgress
                                        className={'flex-1'}
                                        listConfig={listConfig}
                                        product={product}
                                    />
                                )}

                                {/* 提交按钮 */}
                                <ListProductAddToCartBtn addCart={addCart} product={product}/>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
});

export default ListProductShowWholeRow;